import type { FC } from "react";
import { usePackagePrice } from "../usePackagePrice";
import {
    Wrapper,
    TitleContainer,
    Title,
    TextContainer,
    Description,
    StyledRadioButton,
    Tag,
} from "./BillingPeriodStyled";
import type { IBillingPeriod } from "../types";

export const BillingPeriod: FC<IBillingPeriod> = ({ periodItem, currency, selected, onSelection }) => {
    const { sign } = currency;
    const { title, text, tagText } = periodItem;
    const packagePrice = usePackagePrice(periodItem, currency);

    return (
        <Wrapper>
            <StyledRadioButton
                itemSelected={selected}
                buttonSize={"sm"}
                onClick={onSelection}
            />
            <TextContainer>
                <TitleContainer>
                    <Title>{title}</Title>
                    {tagText ? <Tag>{tagText}</Tag> : null}
                </TitleContainer>
                <Description>
                    {sign}
                    {packagePrice}/{text}
                </Description>
            </TextContainer>
        </Wrapper>
    );
};
